<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="800px" persistent scrollable>
      <v-card v-if="showSetUpPicking">
        <v-card-title style="justify-content: center;">{{ $t('pickingForm.title') }}</v-card-title>
        <v-card-text class="center">{{ dialogText }}</v-card-text>
        <v-card-actions class="pa-0">
          <v-btn
              color="primary"
              style="width: 50%"
              tile
              @click="showForm()">
            {{ $t('pickingForm.yes') }}
          </v-btn>
          <v-btn
              class="ml-0"
              color="secondary"
              style="width: 50%"
              tile
              @click="close()">
            {{ $t('pickingForm.no') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <PickingForm
          v-else-if="showFormPicking"
          :pickingAddress="pickingAddress"
          :shippingAddress="shippingAddress"
          :preFillCheckbox="carrierType === 'home_delivery'"
          :settings="settings"
          @validateForm="validateForm" @close="close()" />
    </v-dialog>
  </v-row>
</template>

<script>

import PickingForm from '@/components/PickingForm.vue'

export default ({
  name: 'PickingReturnFormDialog',
  components: { PickingForm },
  data () {
    return {
      createPicking: false,
      showSetUpPicking: true,
      showFormPicking: false,
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    shippingAddress: {
      type: Object,
    },
    carrierType: {
      type: String,
    },
    pickingAddress: {
      type: Object,
    },
    dialogText: {
      type: String,
    },
    settings: {
      type: Object,
      required: true
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    close () {
      this.showFormPicking = false
      this.showSetUpPicking = true
      this.$emit('close')
    },
    showForm () {
      this.showFormPicking = true
      this.showSetUpPicking = false
    },
    validateForm (values) {
      this.$emit('validateForm', values)
      this.close()
    },
  },
})
</script>
